'use client';

import { ImageSlider as MobileImageGallery, FullScreenView } from '@/features/display-carousel';
import { ImageGallery as DesktopImageGallery } from '@/features/image-gallery';
import { useImageNavigation, useImageViewToggle, useIsMobile } from '@/shared/lib/hooks';

interface ImageViewWithCarouselProps {
  pictures: string[];
}

export default function ImageViewWithCarousel({ pictures }: ImageViewWithCarouselProps) {
  const { fullSized, toggleFullSize } = useImageViewToggle();
  const { currentImageIndex, handleImageCurrentIndex } = useImageNavigation();
  const isMobile = useIsMobile();

  return (
    <>
      {fullSized ? (
        <FullScreenView
          pictures={pictures}
          toggleFullSize={toggleFullSize}
          currentImageIndex={currentImageIndex}
          handleImageCurrentIndex={handleImageCurrentIndex}
        />
      ) : isMobile ? (
        <MobileImageGallery
          pictures={pictures}
          toggleFullSize={toggleFullSize}
          currentImageIndex={currentImageIndex}
          handleImageCurrentIndex={handleImageCurrentIndex}
        />
      ) : (
        <DesktopImageGallery
          pictures={pictures}
          handleImageCurrentIndex={handleImageCurrentIndex}
          toggleFullSize={toggleFullSize}
          currentImageIndex={currentImageIndex}
        />
      )}
    </>
  );
}
